<script>
import Layout from '@layouts/loggedin.vue'
import UserEdit from '@router/components/user-edit.vue'
import { authComputed } from '@state/helpers'

export default {
  components: {
    Layout,
    UserEdit,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    companyId() {
      return this.$route.params.companyId
    },
    userId() {
      return this.$route.params.userId
    },
    usersList() {
      return this.$store.state.adminUsers.lists || []
    },
    userItem() {
      if (this.$route.params.item && this.$route.params.item.id) {
        return this.$route.params.item
      } else if (this.usersList.length) {
        return this.usersList.find((item) => item.id === this.userId)
      } else {
        return {}
      }
    },
  },
  mounted() {
    const { userId, item } = this.$route.params
    if (!userId || !item) {
      this.returnUsersList()
    }
  },
  methods: {
    returnUsersList() {
      this.$router.replace({
        name: 'adminUsers',
        params: { companyId: this.companyId },
      })
    }
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white mt-8 mx-7.5 px-20 pt-8 pb-14 rounded-xl shadow-lg">
      <UserEdit :user="userItem" @close="returnUsersList" />
    </div>
  </Layout>
</template>
